import React, { useCallback } from 'react';
import { Switch as MuiSwitch, SwitchProps } from '@mui/material';

const Switch = (props: SwitchProps) => {
  const { onFocus, onBlur, ...rest } = props;
  const handleFocus = useCallback(
    (e: React.FocusEvent<HTMLButtonElement>) => {
      if (onFocus) onFocus(e);
    },
    [onFocus]
  );
  const handleBlur = useCallback(
    (e: React.FocusEvent<HTMLButtonElement>) => {
      if (onBlur) onBlur(e);
    },
    [onBlur]
  );
  return <MuiSwitch {...rest} onFocus={handleFocus} onBlur={handleBlur} />;
};

export default Switch;
